export function showViewer(item) {
  window.open(item.viewerUrl)
}
